export const CHAT_PATH = '/chat';
export const OPEN_AI_CHAT_PATH = '/ai-chat';
export const RAG_CHAT_ASSISTANTS_PATH = '/rag-chat-assistants';
export const RAG_CHAT_COMPLETIONS_PATH = '/rag-chat-completions';
export const DEPOSITION_SUMMARY_PATH = '/deposition-summary';
export const DATABASES = '/databases';
export const BILLING_PATH = '/settings/billing';

export const routes = {
  home: '/home',
  signIn: '/sign-in',
  superAdmin: {
    base: '/admin',
    multiDocumentAgent: {
      base: '/admin/multi-document-agent',
      demandLetter: {
        create: '/admin/multi-document-agent/demand-letter/create',
        edit: (id: number) =>
          `/admin/multi-document-agent/demand-letter/edit/${id}`,
      },
      depositionSummary: {
        create: '/admin/multi-document-agent/deposition-summary/create',
        edit: (id: number) =>
          `/admin/multi-document-agent/deposition-summary/edit/${id}`,
      },
      customGpt: {
        create: '/admin/multi-document-agent/custom-gpt/editor',
        edit: (id: number) =>
          `/admin/multi-document-agent/custom-gpt/editor/${id}`,
      },
      useCase: {
        create: '/admin/multi-document-agent/use-case/create',
        edit: (id: number) => `/admin/multi-document-agent/use-case/edit/${id}`,
      },
    },
    documentPromptPreview: {
      base: '/admin/document-prompt-preview',
      create: '/admin/document-prompt-preview/create',
      edit: (id: number) => `/admin/document-prompt-preview/edit/${id}`,
    },
    documentTemplate: {
      base: '/admin/document-templates',
      create: '/admin/document-templates/create',
      edit: (id: number) => `/admin/document-templates/edit/${id}`,
    },
    tokenUsage: {
      base: '/admin/token-usage',
    },
    creditUsage: {
      base: '/admin/credit-usage',
    },
    // Staff only, no menu link (ZLAYT-1660).
    demandPlayground: {
      base: '/admin/demand-playground',
    },
  },
  settings: {
    subscription: {
      base: '/settings/subscription',
    },
  },
  myDocuments: {
    base: '/my-documents',
    depositionSummary: {
      base: '/my-documents/deposition-summary',
      create: (templateId: number) =>
        `/my-documents/deposition-summary/create/${templateId}`,
      update: (depositionId: number) =>
        `/my-documents/deposition-summary/update/${depositionId}`,
      view: (documentId: number) =>
        `/my-documents/deposition-summary/view/${documentId}`,
    },
    demandLetter: {
      base: '/my-documents/demand-letter',
      create: (templateId: number) =>
        `/my-documents/demand-letter/create/${templateId}`,
      update: (templateId: number) =>
        `/my-documents/demand-letter/update/${templateId}`,
      view: (documentId: number) =>
        `/my-documents/demand-letter/view/${documentId}`,
    },
    customGPT: {
      create: (gptId: number) => `/g/${gptId}`,
      update: (gptId: number, chatId: number) => `/g/${gptId}/c/${chatId}`,
    },
    useCase: {
      base: '/my-documents/use-case',
      create: (templateId: number) =>
        `/my-documents/use-case/create/${templateId}`,
      update: (useCaseId: number) =>
        `/my-documents/use-case/update/${useCaseId}`,
      view: (documentId: number) => `/my-documents/use-case/view/${documentId}`,
    },
  },
  cases: {
    base: '/cases',
    create: '/cases/create',
    edit: (caseId: number) => `/cases/edit/${caseId}`,
    view: (caseId: number) => `/cases/view/${caseId}`,
    chat: (caseId: number) => `/cases/chat/${caseId}`,
    infoSheet: (caseId: number) => `/cases/info-sheet/${caseId}`,
    demandV2: (caseId: number) => `/cases/demand-v2/${caseId}`,
  },
};
